// @flow
import {connect} from 'react-redux';
import BottomNavbar from '../components/BottomNavbar';

import type {RootState} from '../../index';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    storePreviousTier: state.store.storePreviousTier,
  }),
  null
)(BottomNavbar);
